import { FaIndianRupeeSign } from "react-icons/fa6";

export const CURRENCY_SYMBOL = FaIndianRupeeSign